// Referral tracking utilities for partner attribution

const REFERRAL_COOKIE_NAME = 'haven_referral';
const COOKIE_EXPIRY_DAYS = 90;

/**
 * Set referral cookie with partner ID
 */
export const setReferralCookie = (partnerId: string): void => {
  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + COOKIE_EXPIRY_DAYS);
  
  document.cookie = `${REFERRAL_COOKIE_NAME}=${partnerId}; expires=${expiryDate.toUTCString()}; path=/; SameSite=Lax`;
};

/**
 * Get referral partner ID from cookie
 */
export const getReferralCookie = (): string | null => {
  const cookies = document.cookie.split(';');
  
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === REFERRAL_COOKIE_NAME) {
      return value;
    }
  }
  
  return null;
};

/**
 * Get referral from URL parameter or cookie
 */
export const getReferralSource = (): string | null => {
  // First check URL parameter
  const urlParams = new URLSearchParams(window.location.search);
  const urlRef = urlParams.get('ref');
  
  if (urlRef) {
    // Store in cookie for future visits
    setReferralCookie(urlRef);
    return urlRef;
  }
  
  // Fall back to cookie
  return getReferralCookie();
};

/**
 * Clear referral cookie
 */
export const clearReferralCookie = (): void => {
  document.cookie = `${REFERRAL_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

/**
 * Build booking URL with referral tracking
 */
export const buildBookingUrl = (partnerId: string, partnerSlug?: string): string => {
  const baseUrl = window.location.origin;
  const params = new URLSearchParams();
  
  params.append('ref', partnerId);
  if (partnerSlug) {
    params.append('partner', partnerSlug);
  }
  
  return `${baseUrl}/?${params.toString()}`;
};
